import { ICategoryHeader } from "./CategoryHeader";

export const adapterCategoryHeader = (data: any) => {
  let process: ICategoryHeader = {
    breadcrum: data.migaDePan,
    title: data.tituloPrincipal
  };
  return process;
};
